<template>
  <div class="page-card">
    <el-card>
      <div slot="header">客服电话配置</div>
      <p class="hint">此处号码将展示在小程序「客服中心」页面，用户可一键拨打。</p>
      <el-form label-width="120px" style="max-width: 520px;">
        <el-form-item label="客服电话">
          <el-input v-model="phone" placeholder="例如 0731-88888888 或 11 位手机号" clearable />
        </el-form-item>
        <el-form-item label="打卡审核积分">
          <el-input-number v-model="auditPoints" :min="1" :max="9999" />
          <span class="sub-hint">用户上传的打卡点后台审核通过后，自动增加该积分（默认 10）</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'CustomerServiceConfig',
  data() {
    return {
      phone: '',
      auditPoints: 10,
      saving: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      request.get('/configs').then(res => {
        const pack = res.data != null ? res.data : res
        const items = (pack && pack.items) || []
        const byKey = {}
        items.forEach(c => {
          if (c && c.key) byKey[c.key] = c
        })
        if (byKey.customer_service_phone) {
          this.phone = byKey.customer_service_phone.value || ''
        }
        if (byKey.checkin_spot_audit_points) {
          const n = parseInt(byKey.checkin_spot_audit_points.value, 10)
          if (!isNaN(n) && n > 0) this.auditPoints = n
        }
      })
    },
    save() {
      const phone = (this.phone || '').trim()
      if (!phone) {
        this.$message.warning('请填写客服电话')
        return
      }
      this.saving = true
      const p1 = request.post('/configs', {
        key: 'customer_service_phone',
        value: phone,
        description: '小程序客服中心展示号码'
      })
      const p2 = request.post('/configs', {
        key: 'checkin_spot_audit_points',
        value: String(this.auditPoints || 10),
        description: '打卡点审核通过奖励积分'
      })
      Promise.all([p1, p2])
        .then(() => {
          this.$message.success('保存成功')
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style scoped>
.hint {
  color: #606266;
  font-size: 13px;
  margin: 0 0 16px;
}
.sub-hint {
  display: block;
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
</style>
